import React from 'react';
import SlideUpDownNav from './../../inc/SlideUpDownNav';

import SwiperCore, { Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

class DrawingSlider extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { details } = this.props;
        return (
            <section className="mole__project--dcarousel">
                <div className="main-container">
                    <div className="inner-container">
                        {
                            details.project_design_slider &&
                            <Swiper
                                autoplay
                                effect="fade"
                                loop="false"
                                speed={800}
                                navigation={{
                                    prevEl: '.swiper-hero--prev',
                                    nextEl: '.swiper-hero--next',
                                }}
                                pagination={{
                                    el: ".swiper-pagination",
                                    type: "fraction",
                                }}
                            >

                                {
                                    details.project_design_slider.map((slide, index) => {
                                        return (
                                            <SwiperSlide className="bg--white">
                                                <div className="grid">
                                                    <article className="desc">
                                                        <h4 className="font-md">{slide.title}</h4>
                                                        {slide.details &&
                                                            <div dangerouslySetInnerHTML={{ __html: slide.details }} />
                                                        }
                                                    </article>
                                                    <figure className>
                                                        <img src={slide.slider_image.url} alt={details.post_title} />
                                                    </figure>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }



                                <div className="text-right">
                                    <div className="swiper--navs">
                                        <div className="swiper-pagination"></div>

                                        <div className="swiper-nav">
                                            <span className="swiper-hero--prev">
                                                <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                                    <polygon points="4.7,34.1 5.2,34.6 5.2,34.6 15.8,45.3 30.5,60 35.7,54.8 21,40.1 10.3,29.5 20.4,19.3 34.6,5.2 29.5,0  15.3,14.2 5.2,24.3 5.2,24.3 4.8,24.6 0,29.5 0,29.5 " />
                                                </svg>
                                            </span>

                                            <span className="swiper-hero--next">
                                                <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                                    <polygon points="35.7,29.5 35.7,29.5 30.9,24.6 30.5,24.3 30.5,24.3 20.4,14.2 6.2,0 1.1,5.2 15.3,19.3 25.4,29.5 14.7,40.1 0,54.8 5.2,60 19.9,45.3 30.5,34.6 30.5,34.6 31,34.1 " />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Swiper>
                        }
                    </div>
                </div>
            </section>
        );
    }
}
export default DrawingSlider;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/DrawingSlider.js